// extracted by mini-css-extract-plugin
module.exports =  {"floatContainer":"FloatComponent_floatContainer__vPzga","floatReadOnly":"FloatComponent_floatReadOnly__Pb6v4","floatOverride":"FloatComponent_floatOverride__XNNCq"};